import FacilityId                       from "./FacilityId";
import FacilityName                     from "./FacilityName";
import FacilityWebReservationTargetType from "./FacilityWebReservationTargetType";

class Facility {
  constructor(
    private readonly _id: FacilityId = new FacilityId(),
    private readonly _name: FacilityName = new FacilityName(),
    private readonly _targetType: FacilityWebReservationTargetType = FacilityWebReservationTargetType.AVAILABLE,
  ) {
  }

  public isEmpty(): boolean {
    return isNaN(this._id.value);
  }

  get id(): FacilityId {
    return this._id;
  }

  get name(): FacilityName {
    return this._name;
  }

  get targetType(): FacilityWebReservationTargetType {
    return this._targetType;
  }
}

export default Facility;
